import React from 'react';
import ReactConfetti from 'react-confetti';
import { DRAWER_WIDTH } from '@/contexts/order-drawer-context';
import { useLayoutContext } from '@/contexts/layout-context';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  isCelebrating: boolean;
}

export const DynamicConfetti: React.FC<Props> = ({ isCelebrating }) => {
  const { appDimensions } = useLayoutContext();
  const theme = useTheme();

  return isCelebrating ? (
    <ReactConfetti
      colors={[theme.colors.accent, theme.colors.black]}
      height={appDimensions.height}
      width={DRAWER_WIDTH}
    />
  ) : null;
};
